import React, { useState } from 'react'
import { Header1, Input, Button, Text } from '../../styles/Components'
import { ResetFormWrapper } from './styles'
import { FaEye, FaEyeSlash } from 'react-icons/fa'
import { gsColors } from '../../styles/Variables'
import { resetPassword } from '../../services/Authenticator'
import LoadingDot from '../../components/book/steps/components/LoadingDot'

const ResetPasswordForm = ({ token, history, isProvider }) => {
  const [password, setPassword] = useState('')
  const [confirmedPassword, setConfirmedPassword] = useState('')
  const [showPassword, setShowPassword] = useState(false)
  const [showConfirmedPassword, setShowConfirmedPassword] = useState(false)
  const [passwordError, setPasswordError] = useState(null)
  const [changeError, setChangeError] = useState(undefined)
  const [changeSuccess, setChangeSuccess] = useState(false)
  const [confirmedPasswordError, setConfirmedPasswordError] = useState(null)
  const [working, setWorking] = useState(false)

  if (!token) {
    history.push('/signin')
  }

  const submitReset = async () => {
    setWorking(true)
    setPasswordError('')
    setConfirmedPasswordError('')
    setChangeError(false)

    if (password && confirmedPassword && password === confirmedPassword) {
      if (token) {
        try {
          await resetPassword(password, token, isProvider)
          setChangeSuccess(true)
          setWorking(false)
          setTimeout(() => (history.push('/signin')), 4000)
        } catch (error) {
          setWorking(false)
          setChangeError(error.message || 'There was an error changing your password. Please try again.')
          console.error(error)
        }
      }
    }

    if (!password) {
      setPasswordError('Required')
      setWorking(false)
    }
    if (!confirmedPassword) {
      setConfirmedPasswordError('Required')
      setWorking(false)
    }
    if (password && confirmedPassword && password !== confirmedPassword) {
      setConfirmedPasswordError('Passwords must match')
      setWorking(false)
    }
  }

  return (
    <ResetFormWrapper>
      <div className="reset-password-content">
        <Header1>Reset my password</Header1>

        <div className="inputs-container">
          <div className="input-item">
            <label htmlFor="password">Password</label>
            <Input
              id="password"
              data-testid="password"
              name="password"
              type={showPassword ? 'text' : 'password'}
              placeholder="Password"
              value={password}
              onChange={e => setPassword(e.target.value)}
            />
            <span onClick={() => setShowPassword(val => !val)}>
              {showPassword ? (
                <FaEyeSlash style={{ color: gsColors.honeyFlower }} />
              ) : (
                <FaEye style={{ color: gsColors.saltBox }} />
              )}
              <Text
                data-testid="password-error"
                id="password-error"
                variant="small"
                margin="5px 0 0"
                style={{ position: 'absolute' }}
                color={gsColors.errorRed}
              >
                {passwordError}
              </Text>
            </span>
          </div>

          <div className="input-item">
            <label htmlFor="password">Confirm Password</label>
            <Input
              data-testid="confirmedPassword"
              id="confirmedPassword"
              name="confirmPassword"
              type={showConfirmedPassword ? 'text' : 'password'}
              placeholder="Confirm password"
              value={confirmedPassword}
              onChange={e => setConfirmedPassword(e.target.value)}
            />
            <span onClick={() => setShowConfirmedPassword(val => !val)}>
              {showConfirmedPassword ? (
                <FaEyeSlash style={{ color: gsColors.honeyFlower }} />
              ) : (
                <FaEye style={{ color: gsColors.saltBox }} />
              )}
            </span>

            <Text
              data-testid="passwordConfirmed-error"
              id="passwordConfirmed-error"
              variant="small"
              margin="5px 0 0"
              style={{ position: 'absolute' }}
              color={gsColors.errorRed}
            >
              {confirmedPasswordError}
            </Text>
          </div>

          <Button
            data-testid="submit"
            onClick={() => submitReset(password)}
            color={gsColors.sunsetOrange}
            fill
          >
            {!working ? 'Change' : <LoadingDot color={gsColors.white} />}
          </Button>
          {changeError &&
            <Text margin="1rem 0 0" color={gsColors.errorRed}>{changeError}</Text>}
          {changeSuccess &&
            <Text margin="1rem 0 0" color={gsColors.persianGreen}>Your password has been changed! Redirecting you to sign in...</Text>}
        </div>
      </div>
    </ResetFormWrapper>
  )
}

export default ResetPasswordForm
